var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skb"},[(_vm.syx)?_c('div',{staticClass:"sub_title"},[_vm._v("每日8:00-18:30，每30分钟一班，双休日正常运行。")]):_c('img',{staticClass:"my_img",attrs:{"src":require("../../assets/image/skb2.jpg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }